import React, { Component } from 'react'
import Summary from './components/Summary'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'
import styled from 'styled-components'
import { urlAtNotPriv } from '@/actions/checkUrlPriv'
import Statistic from './components/Statistic'
import RecentBlocks from './components/RecentBlocks'
import RecentTransactions from './components/RecentTransactions'
import HotSearch from '@/v2/components/search/HotSearch'

const HomeContainer = styled(Col)`
  margin-bottom: 25px;
`

class Home extends Component {
  componentDidMount() {
    this.props.urlAtNotPrivFunc()
  }
  render() {
    return (
      <HomeContainer>
        <HotSearch />

        <Row gutter={[5, 5]}>
          <Col span={24}>
            <Summary />
          </Col>
        </Row>
        <Statistic />
        <RecentBlocks />
        <RecentTransactions />
      </HomeContainer>
    )
  }
}

const mapStateToProps = (state) => {
  return {}
}
const mapDispatchToProps = (dispatch) => {
  return {
    urlAtNotPrivFunc: () => {
      dispatch(urlAtNotPriv())
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Home)
